// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"306c1546","221":"c510b507","254":"bb750d84","423":"10b24d75","447":"2f477034","838":"6c3c6b2f","865":"a5d71431"}[chunkId] + ".chunk.css";
};